var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrightcove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -1.208 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#95C039",
    d: "M17.292 10.792c-.024 2.922-2.402 5.275-5.323 5.264-2.922-.024-5.275-2.402-5.264-5.324.024-2.909 2.391-5.263 5.3-5.263 2.921-.001 5.287 2.39 5.287 5.323zm6.435 1.146l-4.877 8.499c-.435.676-1.171 1.099-1.979 1.146H7.117c-.81-.048-1.533-.471-1.98-1.146L.273 11.938c-.362-.724-.362-1.581 0-2.293L5.15 1.147C5.583.471 6.32.048 7.128 0h9.754c.809.048 1.545.471 1.979 1.147l4.877 8.498c.351.725.351 1.569-.011 2.293zm-3.73-1.146c-.023-4.418-3.633-7.979-8.052-7.955-4.418.024-7.98 3.633-7.955 8.052.024 4.394 3.598 7.955 8.004 7.955 4.442-.013 8.015-3.622 8.003-8.052z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightcove);
export default __webpack_public_path__ + "static/media/brightcove.d988953e7e954f49165b7f91735f62e4.svg";
export { ForwardRef as ReactComponent };